// Copies each column header into data-label on body cells so CSS can render
// tables as labeled cards on narrow screens.
export function labelTable(table) {
  const heads = [...table.querySelectorAll('thead th')].map((th) => th.textContent.trim());
  table.querySelectorAll('tbody tr').forEach((tr) => {
    [...tr.children].forEach((td, i) => {
      const label = heads[i];
      if (label && td.getAttribute('data-label') !== label) td.setAttribute('data-label', label);
    });
  });
}

export function labelAllTables(root) {
  root.querySelectorAll('table.ui.table').forEach(labelTable);
}
